import React from "react";
import { arrayOf, func, shape, string } from "prop-types";

const Tabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="tabs" role="tablist">
      {tabs.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          role="tab"
          aria-selected={activeTab === key}
          className={`tabs__tab ${
            activeTab === key ? "tabs__tab--active" : ""
          }`}
          onClick={() => onTabChange(key)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

Tabs.propTypes = {
  tabs: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
    })
  ).isRequired,
  activeTab: string.isRequired,
  onTabChange: func.isRequired,
};

export default Tabs;
